import type { Distance, Point } from "@pdfking/math"
import type { PathPoint } from "@pdfking/renderer-api"
import { DrawPath } from "@pdfking/renderer-api"

import type { BoxPointList } from "#internal"

// Two thirds of the way from `p` to `c`: a quadratic's control as a cubic's
// handle
const handle = (p: Point<Distance>, c: Point<Distance>): Point<Distance> => ({
  x: ((p.x + 2 * c.x) / 3) as Distance,
  y: ((p.y + 2 * c.y) / 3) as Distance,
})

/** A die's line as a path: straight between its points, and round the
 * control between two of them as a quadratic curve. */
export const BoxPath = (points: BoxPointList): PathPoint[] =>
  points.reduce<PathPoint[]>((path, point, i) => {
    if (point.control) return path
    const [anchor] = DrawPath([point])
    const control = points[i - 1]
    if (!control?.control) return [...path, anchor!]
    const last = path[path.length - 1]!
    return [
      ...path.slice(0, -1),
      { ...last, after: handle(last, control) },
      { ...anchor!, before: handle(anchor!, control) },
    ]
  }, [])
